import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { useSelector } from 'react-redux';
import { selectCmsSettingsListItems } from '../../../../../../redux/cmsSettings/selector';

export const RateCardBasicInfoComponent = ({ onInnerBasicFormChange, selectedRateCards, shippingProviders }: any) => {
  const cmsSettings = useSelector(selectCmsSettingsListItems)
  const logisticsOrderType = [
    {
      Active: cmsSettings?.result?.items?.LogisticsSettings?.Cargo || false,
      Disabled: false,
      Selected: false,
      Text: 'Cargo',
      Description: 'Cargo',
      Value: 10
    },
    {
      Active: true,
      Disabled: false,
      Selected: false,
      Text: 'Parcel',
      Description: 'Parcel',
      Value: 20
    },

  ]

  return (
    <><AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer

            label="Active"
            name="IsActive"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event,
                'IsActive'
              )
            }}
            type="checkbox"
            value={selectedRateCards?.IsActive}
          />

          <InputContainer
            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'Name'

              )
            }}
            type="text"
            value={selectedRateCards?.Name}
          />
          <InputContainer

            label="Logistics OrderType"
            labelField="Text"
            list={logisticsOrderType.filter((item) => item.Active)}
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'LogisticsOrderType'

              );
            }}
            optionName='Choose OrderType'
            type="select"
            value={selectedRateCards?.LogisticsOrderType}
            valueField="Text"
          />
          <InputContainer
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'Description'

              )
            }}
            type="text"
            value={selectedRateCards?.Description}
          />
          <InputContainer

            label="Logistics Provider"
            labelField="Name"
            list={shippingProviders}
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'LogisticsProviderId'

              );
            }}
            optionName='Choose Logistics Provider'
            type="select"
            value={selectedRateCards?.LogisticsProviderId}
            valueField="Id"
          />
          <InputContainer
            label="Start Date"
            name="StartDateUtc"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'StartDateUtc'
              )
            }}
            type="date"
            value={selectedRateCards?.StartDateUtc}
          />

          <InputContainer
            label="End Date"
            name="EndDateUtc"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'EndDateUtc'
              )
            }}
            type="date"
            value={selectedRateCards?.EndDateUtc}
          />

          <InputContainer
            label="Remarks"
            name="Remarks"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'Remarks'

              )
            }}
            type="text"
            value={selectedRateCards?.Remarks}
          />
          <InputContainer
            label="DisplayOrder"
            name="DisplayOrder"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'DisplayOrder'

              )
            }}
            type="number"
            value={selectedRateCards?.DisplayOrder}
          />




        </div>
      }
      expandedPanel="Basic Info"
      headerTitle="Basic Info"
    />
    </>

  )
}
export default RateCardBasicInfoComponent;
